import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeprecatedConfirmationDialogComponent } from '@app/components';
import { AnalyticEvents } from '@app/enums';
import { TaskTemplate } from '@app/models/tasks/task-template.model';
import { OnboardingTaskTemplateTable } from '@app/modules/employees/services';
import { EmployeeModuleMenuService } from '@app/modules/employees/services/employee-module-menu.service';
import { MenuColumnEvent } from '@app/modules/table/interfaces/menu-column-event.interface';
import { AnalyticService, NotifyService } from '@app/services';
import { AuthService } from '@app/services/auth.service';
import { IndexView } from '@common/views';

@Component({
    templateUrl: './onboarding-task-templates.template.html',
    styleUrls: ['./onboarding-task-templates.style.scss'],
})
export class OnboardingTaskTemplatesView extends IndexView {
    hasTaskPermission = false;

    @ViewChild('confirmDeleteTaskTemplateDialog', { static: true })
    confirmDeleteTaskTemplateDialog: DeprecatedConfirmationDialogComponent;

    constructor(
        public table: OnboardingTaskTemplateTable,
        public analytics: AnalyticService,
        private auth: AuthService,
        private router: Router,
        private route: ActivatedRoute,
        private notify: NotifyService,
        public employeeModuleMenuService: EmployeeModuleMenuService
    ) {
        super();
        this.hasTaskPermission = this.auth.isAdmin() && this.auth.can(TaskTemplate.taskPermission);

        this.table.reload();
    }

    onDelete(taskTemplate: TaskTemplate): void {
        this.setTaskTemplateDeleteDialogHeader(taskTemplate);
        this.confirmDeleteTaskTemplateDialog.show().then((confirm) => {
            if (!confirm) {
                return;
            }

            taskTemplate
                .param('company', taskTemplate.companyId)
                .delete()
                .then(() => {
                    this.notify.success('Task has been deleted');
                    this.analytics.trackEvent(AnalyticEvents.OnboardingTaskTemplateDeleted);
                    this.table.reload();
                })
                .catch((err) => {
                    this.notify.error(err.message || 'Task could not be deleted');
                });
        });
    }

    onNewTask(event: MouseEvent): void {
        event.preventDefault();
        this.analytics.trackEvent(AnalyticEvents.OnboardingTaskTemplateClicked);
        this.router.navigate(['new'], { relativeTo: this.route });
    }

    async onTableMenuEvent(event: MenuColumnEvent): Promise<void> {
        const eventType = event.menuItem.event;
        const taskTemplate = event.data as TaskTemplate;

        switch (eventType) {
            case 'delete':
                this.onDelete(taskTemplate);
                break;
            case 'edit':
                this.router.navigate([String(taskTemplate.id)], { relativeTo: this.route });
                break;
        }
    }

    private setTaskTemplateDeleteDialogHeader(taskTemplate: TaskTemplate): void {
        this.confirmDeleteTaskTemplateDialog.header = `Delete ${taskTemplate.name}?`;
    }
}
